// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3a4Gt","title":"ClientInsurance_title__aHFI4","itemText":"ClientInsurance_itemText__1m4Cy"};